import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/league/label/list',
      data
    });
  },
  createLabel(data) {
    return http.post({
      url: '/la/admin/league/label/create',
      data,
      dataType: 'form'
    });
  },
  removeLabel(data) {
    return http.post({
      url: '/la/admin/league/label/remove',
      data,
      dataType: 'form'
    });
  }
};
